module.exports = __webpack_public_path__ + "img/02.e107cb43.png";